import { LibrarySortDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';

// Shared by the library pages (Quiz questions, Flashcards)
export const LIBRARY_SEARCH_DEBOUNCE_MS = 300;

// Dropdown value meaning "no filter" / "no segment window"
export const ALL_BOOKS = '';
export const SEGMENT_SIZE_ALL = 'all';

export const LIBRARY_SORT_OPTIONS = [
  { name: 'Newest first', value: LibrarySortDto.DESC },
  { name: 'Oldest first', value: LibrarySortDto.ASC },
];
